import { judge_value_valid } from '@/utils/chart/verification.js'

export const get_dom_width = (dom, margin) => {   
    const client_width = dom.clientWidth
    const margin_width = margin ? margin.left + margin.right : 100
    const is_mobile = window.innerWidth < 768;

    return is_mobile ? 668 : client_width - margin_width; 
}

export const get_diagram_shape = (choosed_time_series_data) => {
    const ignore_None_data = choosed_time_series_data.filter(val => judge_value_valid(val))
    
    if (ignore_None_data.every(item => item >= 0)){
        return 'down_to_up'
    } 
    
    if (ignore_None_data.every(item => item <= 0)) {
        return 'up_to_down'
    }
    
    return 'from_center'
}

export const init_chart_resize_observer = function(ref_dom, margin) {
    return new ResizeObserver(() => {
        this.width = get_dom_width(ref_dom, margin)
        this.height = this.basic_layout_setting.height || ref_dom.clientHeight - 95
        this.rerender_svg()
    })
}